import angular from 'angular';
import uiRouter from 'angular-ui-router';
import ProfileRegistryComponent from './registry.component';
const profileRegistryModule = angular.module('tinaba.components.profile.registry', [
  uiRouter,
  'ngImgCrop'
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('profile.registry', {
      url: '/registry',
      template: '<profile-registry></profile-registry>'
    });
})

.component('profileRegistry', ProfileRegistryComponent);

export default profileRegistryModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/profile/registry/registry.js
 **/